import type { QuarrySiteDto } from '@/api/hooks'

/**
 * Le marqueur de la carrière du Grand Chantier sur la carte.
 *
 * Comme la bête de fin de saison, ce n'est PAS une île : pas de brouillard à
 * lever, pas de fiche, pas de commerce, aucun filtre de légende à traverser. Elle
 * vit donc sur un champ racine du payload de carte, à côté des îles.
 *
 * Contrairement au marqueur de la bête, celui-ci n'est PAS cliquable, et c'est
 * délibéré : la carrière n'a pas de panneau à ouvrir, tout se joue sur l'écran du
 * Grand Chantier. Un `<button>` qui n'ouvre rien resterait tabulable et
 * trompeur, donc on rend un simple `<div>` décoratif avec son `title`, et le
 * `KrakenMarker` garde son garde-fou « pas de marqueur sans handler ».
 *
 * Rendu en HTML absolu et non en SVG, pour rester cohérent avec les marqueurs
 * d'île du même conteneur transformé : même contre-scale, même géométrie.
 */
export function QuarryMarker({
  site,
  gridSize,
  k,
}: {
  site: QuarrySiteDto
  gridSize: number
  /** Échelle courante du conteneur zoomable : on la compense pour garder une taille stable. */
  k: number
}) {
  const left = `${(site.x / gridSize) * 100}%`
  const top = `${(site.y / gridSize) * 100}%`

  return (
    <div
      data-testid="quarry-marker"
      title={`${site.label} · ${site.distanceLeagues} lieues`}
      aria-hidden="true"
      className="absolute z-10 pointer-events-none"
      style={{ left, top, transform: `translate(-50%, -50%) scale(${1 / k})` }}
    >
      <svg viewBox="0 0 40 40" className="w-9 h-9 drop-shadow-[0_0_6px_rgba(143,209,223,0.55)]">
        {/* Un tas de pierre taillée, dans la grammaire en line-art dorée du reste
            de la carte : deux blocs et un éclat, sans remplissage plein. */}
        <circle cx="20" cy="20" r="13" fill="#0A3E4F" fillOpacity="0.72" stroke="#8FD1DF" strokeWidth="1.2" />
        <path
          d="M11 25 l4 -7 h8 l4 7 z"
          fill="#8FD1DF"
          fillOpacity="0.35"
          stroke="#BFE4ED"
          strokeWidth="1.1"
          strokeLinejoin="round"
        />
        <path d="M16 18 l4 -6 4 6" fill="none" stroke="#BFE4ED" strokeWidth="1.1" strokeLinejoin="round" />
      </svg>
    </div>
  )
}
